import React from 'react';
import './common.scss';

interface WizardNavProps {
  prevButton: React.ReactNode;
  nextButton: React.ReactNode;
}

function WizardNav({ prevButton, nextButton }: WizardNavProps) {
  return (
    <nav
      role='navigation'
      aria-label='Test Day Proctor Wizard Steps'
      id='wizard-navigation'
      className='wizard-nav-container'
    >
      <div className='wizard-nav d-flex container'>
        {prevButton}
        {nextButton}
      </div>
    </nav>
  );
}

export default WizardNav;
